import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-267">
      <div className="max-w-3xl mx-auto text-center" data-id="element-268">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-269">
          Si sos docente de Francés en Argentina,
          <br data-id="element-270" />
          <span className="text-[#00B4D8]" data-id="element-271">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-272">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-273">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-274">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-275">
              Domingo a la noche buscando actividades que no se adaptan al
              alumno argentino
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-276">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-277">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-278">
              Llegás al lunes con algo que "más o menos sirve" — sin estructura
              ni solucionario
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-279">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-280">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-281">
              Planificaciones armadas a las corridas la noche anterior
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-282">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-283">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-284">
              Evaluaciones siempre inventadas, sin banco de instrumentos serios
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-285">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-286">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-287">
              No sabés cómo explicar el subjonctif o el conditionnel sin perder
              al grupo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-288">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-289">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-290">
              Grupos mezclados (A1+A2) sin material diferenciado — das para el
              promedio y perdés a todos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-291">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-292">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-293">
              Fin de año sin registros ni evidencia profesional para mostrar a
              dirección
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-294">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-295">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-296">
              El ciclo se repite cada semana y cada domingo
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-2xl sm:text-3xl font-black mb-8" data-id="element-297">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Blue divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-298" />
      </div>
    </section>;
}